// extracted by mini-css-extract-plugin
export default {"tabs_wrapper":"calculator_tabs_wrapper__Jfpbe","nactive":"calculator_nactive__KJRPJ","bactive":"calculator_bactive__KN4kz"};